/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbEntitecentreDto
 */
export interface FcbEntitecentreDto {
    /**
     * 
     * @type {number}
     * @memberof FcbEntitecentreDto
     */
    identite?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbEntitecentreDto
     */
    nom?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbEntitecentreDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbEntitecentreDto interface.
 */
export function instanceOfFcbEntitecentreDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEntitecentreDtoFromJSON(json: any): FcbEntitecentreDto {
    return FcbEntitecentreDtoFromJSONTyped(json, false);
}

export function FcbEntitecentreDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEntitecentreDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'identite': !exists(json, 'identite') ? undefined : json['identite'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbEntitecentreDtoToJSON(value?: FcbEntitecentreDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'identite': value.identite,
        'nom': value.nom,
        'actif': value.actif,
    };
}

